import React from 'react';
import { CheckCircle, AlertTriangle, XCircle } from 'lucide-react';

const ICONS = {
  ok: <CheckCircle strokeWidth={1.5} size={18} className="text-green-600" />,
  warning: <AlertTriangle strokeWidth={1.5} size={18} className="text-yellow-500" />,
  problem: <XCircle strokeWidth={1.5} size={18} className="text-red-600" />,
};

const DreamInsight = ({ type, text }) => (
  <div className="flex items-start gap-2 text-base text-blueDark leading-relaxed">
    <div className="pt-1">{ICONS[type]}</div>
    <p className="flex-1">{text}</p>
  </div>
);

export default DreamInsight;
